var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background"},[_c('slide-y-up-transition',{attrs:{"mode":"out-in","origin":"center top"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }